import BlogPostContainer from "./BlogPostContainer";

const Thailand2025 = () => {
    const blogPosts = [
        {
            date: "22. - 28.09.2025",
            title: "Koh Samui",
            content: (
                <>
                </>
            ),
            images: [
                "/images/10_Thailand/3.1.jpg",
                "/images/10_Thailand/3.2.jpg",
                "/images/10_Thailand/3.3.jpg",
            ]
        },
        {
            date: "17. - 22.09.2025",
            title: "Koh Tao",
            content: (
                <>
                </>
            ),
            images: [
                "/images/10_Thailand/2.1.jpg",
                "/images/10_Thailand/2.2.jpg",
                "/images/10_Thailand/2.3.jpg",
                "/images/10_Thailand/2.4.jpg",
            ]
        },
        {
            date: "13. - 17.09.2025",
            title: "Chiang Mai",
            content: (
                <>
                </>
            ),
            images: [
                "/images/10_Thailand/1.1.jpg",
                "/images/10_Thailand/1.2.jpg",
                "/images/10_Thailand/1.3.jpg",
            ]
        },
    ];
    return (
        <div className="container my-5">
            <div>
                <h2 className="Blog_Title">Thailand</h2>
            </div>
            {blogPosts.map((post, index) => (
                <BlogPostContainer
                    index={index}
                    title={post.title}
                    date={post.date}
                    content={post.content}
                    images={post.images}
                />
            ))}
        </div>
    );
}
export default Thailand2025;